/*
 * Smooth scrolling, through Lenis (assets/lenis.min.js).
 *
 * Lenis smooths the real scroll position rather than transforming the page,
 * so sticky elements, IntersectionObserver and the scroll-linked effects on
 * this theme keep working. Three things it does need from us: it is turned
 * off for reduced motion, it is paused whenever a drawer or the mobile menu
 * holds the screen, and in-page links are handed to it so they still glide.
 */
(function () {
  if (typeof Lenis === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var lenis = new Lenis({
    duration: 1.05,
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
    smoothWheel: true,
    // Touch devices already have momentum from the OS; a second layer on top
    // of it feels wrong, so phones keep their native scrolling.
    syncTouch: false,
    // Lenis is stopped while a drawer is open, and a stopped Lenis cancels
    // every wheel event, so the drawer's own list could not scroll. Wheel
    // events inside these panels are left to the browser.
    prevent: function (node) {
      return node.matches('cart-drawer, .drawer, .mobile-menu, quick-add-modal, .search-modal, .menu-drawer');
    }
  });

  window.lenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  /* Anchor links: the CSS smooth behaviour is off while Lenis runs, so the
     jump is handed to it instead. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link || link.target === '_blank') return;

    var url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || url.host !== window.location.host) return;
    if (!url.hash || url.hash === '#') return;

    var target = document.querySelector(url.hash);
    if (!target) return;

    event.preventDefault();
    lenis.scrollTo(target, { offset: -20 });
  });

  /* The page must hold still behind a drawer. Only signals that mean *open*
     are read: the cart drawer keeps its 'animate' class after closing, so
     that one cannot be used. */
  var OPEN = [
    'cart-drawer.active',
    '.drawer.active',
    'quick-add-modal[open]',
    '.search-modal.modal--open',
    'details[open] > .menu-drawer'
  ].join(', ');

  function syncLock() {
    var locked = !!document.querySelector(OPEN) ||
      document.body.classList.contains('overflow-hidden') ||
      document.documentElement.classList.contains('overflow-hidden');

    if (locked === lenis.isStopped) return;
    if (locked) lenis.stop();
    else lenis.start();
  }

  var observer = new MutationObserver(syncLock);
  observer.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'aria-hidden']
  });

  syncLock();
})();
